module.exports = __webpack_public_path__ + "static/media/portfolio1 (16).a4cf7260.jpeg";